/**
 * Client typé pour les routes `/school` — Phase 4, incrément 4.10.5,
 * étendu **offline-first** en Phase 3.3.3.
 *
 * Dernière sub-entité coparenting. 3 méthodes (pas de update) —
 * pattern symétrique à journal/expenses, avec un `type` discriminant
 * en plus. Mutations passent par `sendOrQueueMutation` (cf. 3.3.2).
 */
import { apiRequest } from './client.js';
import { sendOrQueueMutation, type SendResult } from './mutationsReplay.js';

export type ApiSchoolType = 'note' | 'devoir' | 'info';

export interface ApiSchoolEntry {
  id: string;
  homeId: string;
  type: ApiSchoolType;
  subject: string | null;
  teacher: string | null;
  comment: string | null;
  value: string | null;
  date: string;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSchoolEntryInput {
  type: ApiSchoolType;
  subject?: string;
  teacher?: string;
  comment?: string;
  value?: string;
  /** `YYYY-MM-DD`. Si absente, le serveur applique aujourd'hui. */
  date?: string;
}

export async function listSchoolEntries(homeId: string): Promise<ApiSchoolEntry[]> {
  const data = await apiRequest<{ entries: ApiSchoolEntry[] }>(`/homes/${homeId}/school`);
  return data.entries;
}

export async function createSchoolEntry(
  homeId: string,
  input: CreateSchoolEntryInput,
  localId?: string,
): Promise<SendResult<{ entry: ApiSchoolEntry }>> {
  return sendOrQueueMutation<{ entry: ApiSchoolEntry }>({
    method: 'POST',
    path: `/homes/${homeId}/school`,
    body: input,
    ...(localId ? { localId } : {}),
  });
}

export async function deleteSchoolEntry(id: string): Promise<SendResult<void>> {
  return sendOrQueueMutation<void>({
    method: 'DELETE',
    path: `/school/${id}`,
  });
}
